import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import { Breadcrumb, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useUrlSearchParams } from "use-url-search-params";
import { useList } from "modules/mandatoryRequirement/hooks";
import Pagination from "containers/Pagination";
import FilterList from "./components/FilterList";
import Button from "components/Button";
import * as Icons from "assets/icons";
import { useNavigate } from "react-router";
import { useQueryClient } from "react-query";
import { ENTITY } from "modules/mandatoryRequirement/constants";
import { renderTextWithLink } from "lib/renderTextWithLink";

const ServiceRegister = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [params, setParams] = useUrlSearchParams();
    const queryClient = useQueryClient();
    const [search, setSearch] = useState(0);

    const defaultParams = {
        search,
        page: params.page,
        filter: [
            {
                key: "info1",
                operation: "%_%",
                value: params.requirement_name,
                type: "JSON",
            },
            {
                key: "createdByOrganizationId",
                operation: "=",
                value: params.organizationId,
                type: "NUMBER",
            },
            {
                key: "okedId",
                operation: "=",
                value: params.okedId,
                type: "NUMBER",
            },
            // {
            //     key: `type`,
            //     operation: "=",
            //     value: params.type,
            //     type: "STRING",
            // },
        ],
    }
    const { items, meta, isFetched } = useList({
        params: defaultParams
    });

    function handleRowClick(record) {
        localStorage.clear();
        localStorage.setItem(record.id, JSON.stringify(record));
        queryClient.setQueryData([ENTITY, String(record.id)], record);
        navigate(`/mandatory-requirement/view/${record.id}`);
    }

    return (
        <>
            <Container>
                <Spacer size={35} />

                <Breadcrumb separator=">">
                    <Breadcrumb.Item href="/">{t('home')}</Breadcrumb.Item>
                    <Breadcrumb.Item href="/mandatory-requirement/register">{t('mandatory-requirements')}</Breadcrumb.Item>
                    <Breadcrumb.Item>{t("mandatory-requirements-list")}</Breadcrumb.Item>
                </Breadcrumb>

                <Spacer size={32} />

                <Title align="left" text={t("mandatory-requirements")} />
                <Spacer size={40} />


                <FilterList {...{ params, setParams, setSearch }} />
                {/*<ExcelDownload defaultParams={defaultParams} />*/}


                <Spacer size={20} />
                <Table
                    rowKey="id"
                    columns={[
                        {
                            title: "ID",
                            dataIndex: "id"
                        },
                        {
                            key: "info1",
                            title: t("mandatory-requirements-table-info1"),
                            dataIndex: ["info1", i18n.language],
                            width: "25%",
                            render: (value) => (<div dangerouslySetInnerHTML={{ __html: value }}></div>)
                        },
                        {
                            key: "info2",
                            title: t("mandatory-requirements-table-info2"),
                            dataIndex: ["info2", i18n.language],
                            width: "50%",
                            render: (value) => (<div dangerouslySetInnerHTML={{ __html: renderTextWithLink(value) }}></div>)
                        },
                        {
                            key: "info4",
                            title: t("mandatory-requirements-table-info3"),
                            width: 200,
                            dataIndex: ["info4", i18n.language],
                            render: (value) => (<div dangerouslySetInnerHTML={{ __html: value }}></div>)
                        },
                        {
                            key: "actions",
                            width: 50,
                            render: (_, record) => (
                                <Button
                                    background="secondary"
                                    color="secondary"
                                    border="none"
                                    radius="xs"
                                    iconOnly
                                    onClick={() => handleRowClick(record)}
                                >
                                    <Icons.ArrowRight />
                                </Button>
                            ),
                        },
                    ]}
                    dataSource={items}
                    pagination={false}
                    loading={!isFetched}
                    onRow={record => {
                        return {
                            onClick: event => {
                                if (event.target.localName === "td")
                                    handleRowClick(record);
                            },
                        };
                    }}
                    scroll={{ x: 1400 }}
                />

                <Spacer size={32} />

                <Pagination
                    current={meta.current}
                    total={meta.totalPages}
                    currentItems={items.length}
                    totalItems={meta.totalItems}
                    onChange={(page) => setParams({ page })}
                />

                <Spacer size={140} />
            </Container>
            {/*<QuickViewModal item={isModal} onCancel={() => setModal({})} />*/}
        </>
    );
};

export default ServiceRegister;
